/* eslint-disable no-prototype-builtins */
/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import axios from 'axios'
// import jwtDecode from 'jwt-decode'
import { jwtDecode } from 'jwt-decode'

import { handleChange, validEmail } from '../../../helpers/globalHelpers.js'
import { setTokenToLocalStorage, setEmailToLocalStorage, getUserIdFromToken, setIsReviewerToLocalStorage } from '../../../helpers/storage.js'
import { loginTextField } from '../../../helpers/textfields.js'
import { standardSubmitButton, handleSwitchLoginRegisterButton, standardButton } from '../../../helpers/buttons.js'
import { loginRegisterErrors, standardErrorContainer } from '../../../helpers/errors.js'
import { profPicDefaultURL, positionChangeWidthSm, subscriptionTypes, swipelyticsPink, oneTimeRate, yearlyRate, monthlyRate, swipelyticsTurquoise } from '../../../helpers/variableDefaults.js'
import { standardSpinner } from '../../../helpers/spinners.js'
import { acceptTOSCheckbox } from '../../../helpers/checkboxes.js'
import { selectElement, selectElementHandleChange } from '../../../helpers/selects.js'
import { numberWithCommas, isInstagramOrFacebook, handleOpenInBrowser } from '../../../helpers/globalHelpers.js'
import { dividerWithText } from '../../../helpers/dividers.js'
import { advisoryTypography } from '../../../helpers/typographies.js'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Divider from '@mui/material/Divider'


// Proceed to next view, depending on the fromComponent
export const proceedToNextView = (fromComponent, navigate, userId, isNewUser) => {

  // console.log('isNewUser ->', isNewUser)

  if (fromComponent === '/login' && !isNewUser) {
    navigate(`/dashboard/${userId}`, { state: { previousLocationPathname: window.location.pathname } })
  } else if (fromComponent === '/create-account' || isNewUser) {
    // navigate(`/onboarding/${userId}`)
    navigate(`/dashboard/${userId}`, { state: { previousLocationPathname: window.location.pathname } })
  }
}

// Reset all auth errors and Loadings
export const resetAllAuthErrors = (setLoadingLogin, setLoginErrors, setLoadingRegister, setRegisterErrors, setLoadingGoogle, setGoogleLoginErrors, setLoadingFacebook, setFacebookLoginErrors) => {
  // Reset error states
  setLoginErrors(false)
  setRegisterErrors({})
  setGoogleLoginErrors(false)
  setFacebookLoginErrors(false)

  // Reset Loading states
  // setLoadingLogin(false)
  // setLoadingRegister(false)
  // setLoadingGoogle(false)
  // setLoadingFacebook(false)
}

// Code inside 'try' part of try/catch when attempting a login
const loginTry = async (fromComponent, setLoading, setErrors, formToUpload, navigate) => {
  
  // Set Loading
  // setLoading(true)

  // Upload Login/Register Form to server
  const { data } = await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/auth/`, formToUpload)

  // Set these to local storage after answering security question
  setTokenToLocalStorage(data.token)
  setEmailToLocalStorage(data.email)
  setIsReviewerToLocalStorage(data.isReviewer)

  // Depending on the component the login occurs in, go to the appropriate next view
  proceedToNextView(fromComponent, navigate, getUserIdFromToken(data.token), 'isNewUser' in data ? data.isNewUser : false)

  // Set loading and login errors to false
  // setLoading(false)
  setErrors(false)
}

// Code inside 'catch' part of try/catch when attempting to login
const loginCatch = async (err, setLoading, setErrors) => {
  // console.log('err: ', err.message)
  setLoading(false)
  setErrors(true)
}

// Code inside 'catch' part of try/catch when attempting to register
// Necessary because we want Register error messages to be more specific than login error messages
const registerCatch = async (err, setLoading, errors, setErrors) => {
  // console.log('err ->', err.response)
  const errorObj = err.response.data.errors
  const messageToReturn = errorObj[Object.keys(errorObj)[0]].message.includes('Value:') ? errorObj[Object.keys(errorObj)[0]].message.split(' Value:')[0] : errorObj[Object.keys(errorObj)[0]].message

  // console.log('error message ->', errorObj[Object.keys(errorObj)[0]].message)
  // console.log('message to return ->', messageToReturn)

  setLoading(false)
  setErrors({ ...errors, [Object.keys(errorObj)[0]]: messageToReturn })
}

// The try/catch when attempting to log in
const loginTryCatch = async (fromComponent, setLoading, setErrors, formToUpload, navigate) => {
  try {
    await loginTry(fromComponent, setLoading, setErrors, formToUpload, navigate)

  } catch (err) {
    await loginCatch(err, setLoading, setErrors)
  }
}


// Email/Password login attempt submitted
const handleSubmitLogin = async (
  e, fromComponent, loginForm, setLoginErrors, setRegisterErrors, setLoadingLogin, setLoadingRegister, navigate,
  setLoadingGoogle, setGoogleLoginErrors, setLoadingFacebook, setFacebookLoginErrors
) => {
  e.preventDefault()
  setLoadingLogin(true)
  window.scrollTo(0, 0)

  // reset all error states
  resetAllAuthErrors(setLoadingLogin, setLoginErrors, setLoadingRegister, setRegisterErrors, setLoadingGoogle, setGoogleLoginErrors, setLoadingFacebook, setFacebookLoginErrors)

  if (loginForm.email && loginForm.password) {

    // Upload login form to server to execute login
    await loginTryCatch(fromComponent, setLoadingLogin, setLoginErrors, loginForm, navigate)

  } else {
    // console.log('login form not complete')

    // Set errors to true if the email or password is missing
    setLoadingLogin(false)
    setLoginErrors(true)
  }
}

// Email/Password register attempt submitted
const handleSubmitRegister = async (
  e, fromComponent, registerForm, registerErrors, setLoginErrors, setRegisterErrors, setLoadingLogin, setLoadingRegister, navigate, 
  setLoadingGoogle, setGoogleLoginErrors, setLoadingFacebook, setFacebookLoginErrors
) => {
  e.preventDefault()

  // reset all error states
  resetAllAuthErrors(setLoadingLogin, setLoginErrors, setLoadingRegister, setRegisterErrors, setLoadingGoogle, setGoogleLoginErrors, setLoadingFacebook, setFacebookLoginErrors)

  if (registerForm.email && registerForm.password && registerForm.passwordConfirmation && (registerForm.password === registerForm.passwordConfirmation)) {
    try {
      setLoadingRegister(true)
      window.scrollTo(0, 0)
      // upload register form to server to execute login/register
      await loginTry(fromComponent, setLoadingRegister, setRegisterErrors, registerForm, navigate)

      // Update States
      setLoadingRegister(false)
      
    } catch (err) {
      console.log('register error ->', err)

      // Catch Register errors if there are any
      await registerCatch(err, setLoadingRegister, registerErrors, setRegisterErrors)
      
    }
  } else if (registerForm.password !== registerForm.passwordConfirmation) {
    // console.log('password does not match password confirmation')

    // If there's an error, pass this message
    setLoadingRegister(false)
    setRegisterErrors({ ...registerErrors, passwordConfirmation: 'password and password confirmation do not match' })
  } else {
    // console.log('register form not complete')

    // If there's an error, pass this message
    setLoadingRegister(false)
    setRegisterErrors({ ...registerErrors, passwordConfirmation: 'All fields are required' })
  }
}

// Email/Password Login Elements
export const inProcessLogin = (fromComponent, loginForm, setLoginForm, loginErrors, setLoginErrors, loadingLogin, setLoadingLogin, loginViewIndex, setRegisterErrors, setLoadingRegister, setLoadingGoogle, setGoogleLoginErrors, setLoadingFacebook, setFacebookLoginErrors, navigate, width) => {

  return (
    <Box component="form" 
      onSubmit={(e) => handleSubmitLogin(e, fromComponent, loginForm, setLoginErrors, setRegisterErrors, setLoadingLogin, setLoadingRegister, navigate, setLoadingGoogle, setGoogleLoginErrors, setLoadingFacebook, setFacebookLoginErrors)} 
      noValidate 
      sx={{ 
        mt: 3, mb: 3, 
        width: '85%',
        maxWidth: '275px',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
      }}
    >
      <Box 
        sx={{ 
          pb: 3, pt: 2, mt: 0, mb: 0,
          width: '100%',
          backgroundColor: 'whitesmoke',
          boxShadow: 3, borderRadius: 3,
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        }}
      >
      
        {/* Email */}
        <Box sx={{ mb: 1, width: '90%' }}>
          {loginTextField('email', 'Email Address', loginForm.email, 'outlined', true, true, true, 'email', loginForm, setLoginForm, setLoginErrors, handleChange )}
        </Box>
        
        {/* Password */}
        <Box sx={{ mt: 1, width: '90%' }}>
          {loginTextField('password', 'Password', loginForm.password, 'outlined', true, true, false, 'current-password', loginForm, setLoginForm, setLoginErrors, handleChange )}
        </Box>
      </Box> 
        
      {/* Errors if there are errors */}
      {loginRegisterErrors(loginErrors, 'Unauthorised.', 1, 0)}

      {/* Submit button */}
      <Box 
        sx={{ 
          mt: 1, mb: 1, 
          width: '100%', 
          display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', 
        }}
      >
        {standardSubmitButton('Sign In', 'submit', false, 'primary', 2, 2, '150px', '50px')}
      </Box>

      {/* Link to Reset Password */}
      <Box sx={{ 
        width: '100%',
        display: 'flex', flexDirection: 'row', justifyContent: 'center',
      }}>
        <Button 
          onClick={(e) => navigate('/reset-password')} 
          variant="text" 
          color='secondary'
          sx={{ 
            mt: 0,
            width: '150px', 
            height: '40px', 
            display: 'flex', flexDirection: 'row', justifyContent: 'center',
          }}
        >
          Reset Password
        </Button>
      </Box>
    </Box>
  )
}

// Email/Password Register Elements
export const inProcessRegister = (
  fromComponent, registerForm, setRegisterForm, registerErrors, setRegisterErrors, loadingRegister, setLoadingRegister, acceptedTOS, setAcceptedTOS, loginViewIndex, setLoginErrors, setLoadingLogin, navigate, 
  setLoadingGoogle, setGoogleLoginErrors, setLoadingFacebook, setFacebookLoginErrors,
  // stripe, elements, 
  width
) => {
  
  return (
    <Box component="form" noValidate 
      onSubmit={(e) => handleSubmitRegister(
        e, fromComponent, registerForm, registerErrors, setLoginErrors, setRegisterErrors, setLoadingLogin, setLoadingRegister, navigate, 
        // stripe, elements
        setLoadingGoogle, setGoogleLoginErrors, setLoadingFacebook, setFacebookLoginErrors
      )} 
      sx={{ 
        mt: 3, mb: 3, 
        width: '85%',
        maxWidth: '275px',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
      }}
    >
      {/* Email, Password, Password Confirmation */}
      <Box 
        sx={{ 
          pb: 3, pt: 2, mb: 1,
          width: '100%',
          backgroundColor: 'whitesmoke',
          boxShadow: 3, borderRadius: 3,
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        }}
      >

        {/* Email */}
        <Box sx={{ mb: 1, mt: 1, width: '90%' }}>
          {loginTextField('email', 'Email Address', registerForm.email, 'outlined', true, true, false, 'new-password', registerForm, setRegisterForm, setRegisterErrors, handleChange )}
        </Box>

        {/* Error message under email if it's an email error */}
        <Box sx={{ mb: 0, mt: 0, width: '90%' }}>
          {loginRegisterErrors(registerErrors.email, registerErrors.email, 0, 1)}
        </Box>

        {/* Password */}
        <Box sx={{ mb: 1, mt: 1, width: '90%' }}>
          {loginTextField('password', 'Password', registerForm.password, 'outlined', true, true, false, 'new-password', registerForm, setRegisterForm, setRegisterErrors, handleChange )}
        </Box>

        {/* Error message under password if it's a password error */}
        <Box sx={{ mb: 0, mt: 0, width: '90%' }}>
          {loginRegisterErrors(registerErrors.password, registerErrors.password, 0, 1)}
        </Box>

        {/* Password Confirmation */}
        <Box sx={{ mb: 1, mt: 1, width: '90%' }}>
          {loginTextField('passwordConfirmation', 'Password Confirmation', registerForm.passwordConfirmation, 'outlined', true, true, false, 'new-password', registerForm, setRegisterForm, setRegisterErrors, handleChange )}
        </Box>

        {/* Error message under password confirmation if it's a password confirmation error */}
        <Box sx={{ mb: 0, mt: 0, width: '90%' }}>
          {loginRegisterErrors(registerErrors.passwordConfirmation, registerErrors.passwordConfirmation, 0, 1)}
        </Box>
      </Box>

      
      {/* Terms of Service and Privacy Policy Checkbox */}
      <Box
        sx={{ 
          width: '100%',
          fontSize: '13px',
          mb: 1, mt: 1,
          pl: 1, pr: 1, pt: 1,
          display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', flexWrap: 'wrap',
          overflow: 'visible',
        }}
      >
        {acceptTOSCheckbox('acceptedTOS', acceptedTOS, setAcceptedTOS)}
      </Box>

      {/* Register Button */}
      {/* {console.log('registerForm ->', registerForm)} */}
      <Box sx={{ mb: 1, mt: 1, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        {standardSubmitButton(
          'Create', 
          'submit', 
          !(
            registerForm.hasOwnProperty('email') && registerForm.email.length > 0 && 
            registerForm.hasOwnProperty('password') && registerForm.password.length > 0 
            && registerForm.hasOwnProperty('passwordConfirmation') && registerForm.passwordConfirmation.length > 0 
            && acceptedTOS
          ), 
          'primary', 
          2, 
          2, 
          '150px', 
          '50px'
        )}

        {/* Error message under email if it's an email error */}
        {loginRegisterErrors(registerErrors.email, registerErrors.email, 0, 1)}

        {/* Error message under password if it's a password error */}
        {loginRegisterErrors(registerErrors.password, registerErrors.password, 0, 1)}

        {/* Error message under password confirmation if it's a password confirmation error */}
        {loginRegisterErrors(registerErrors.passwordConfirmation, registerErrors.passwordConfirmation, 0, 1)}
      </Box>
    </Box>
  )
}



// Google Sign In Button and Callback
export const createGoogleSignInButton = async (fromComponent, setGoogleLoginErrors, setFacebookLoginErrors, setLoginErrors, setRegisterErrors, setLoadingGoogle, setLoadingFacebook, setLoadingLogin, setLoadingRegister, navigate) => {
  
  // ! The 'global google' below is necessary, don't change or delete it 
  /* global google */
  
  // If the global google variable exists, create the google login button
  if (typeof google !== 'undefined' && google) {
    google.accounts.id.initialize({
      client_id: process.env.REACT_APP_GOOGLE_LOG_IN_WEB_CLIENT_ID,
      callback: async function (response) {

        // Set Loading
        setLoadingGoogle(true)
        window.scrollTo(0, 0)

        // reset all error states
        resetAllAuthErrors(setLoadingLogin, setLoginErrors, setLoadingRegister, setRegisterErrors, setLoadingGoogle, setGoogleLoginErrors, setLoadingFacebook, setFacebookLoginErrors)
        
        // Decode the JSON credential into an object
        const userObject = jwtDecode(response.credential)

        // Create the object to upload
        const googleFormToUpload = {
          email: userObject.email,
          password: userObject.sub ? `swipelytics${userObject.sub}` : 'swipelyticsp4$$w0rd!', // .sub is the user's Google user id
          passwordConfirmation: userObject.sub ? `swipelytics${userObject.sub}` : 'swipelyticsp4$$w0rd!',
          loginMethod: 'google',
          acceptedTOS: true,
        }

        // If none of the required form fields are empty, POST the form data to the register endpoint and then navigate to /login
        if (
          googleFormToUpload.email.length > 0 
          && googleFormToUpload.password.length > 0  
          && googleFormToUpload.passwordConfirmation.length > 0  
        ) {
          // Upload form to server to execute Login/Register
          await loginTryCatch(fromComponent, setLoadingGoogle, setGoogleLoginErrors, googleFormToUpload, navigate)

        } else {
          console.log('register form not complete')

          // If there's an error, pass this message
          setLoadingGoogle(false)
          setGoogleLoginErrors(true)
        }
      },
    })

    // Display the Google Sign-In Button
    await google.accounts.id.renderButton(
      document.getElementById('signInDiv'),
      { theme: 'outlined', size: 'large', width: 250 }
    )
  }
}

// All Auth Elements: Email/Password Login and Register Options
export const inProcessAllAuth = (
  fromComponent, loginViewIndex, loginForm, setLoginForm, loginErrors, setLoginErrors, loadingLogin, setLoadingLogin, registerForm, setRegisterForm, registerErrors, setRegisterErrors, loadingRegister, setLoadingRegister, acceptedTOS, setAcceptedTOS, navigate, 
  googleLoginErrors, facebookLoginErrors,
  setLoadingGoogle, setGoogleLoginErrors, setLoadingFacebook, setFacebookLoginErrors,
  width 
) => {

  return (
    <>
      {/* Google Login Button — if the global google variable exists */}
      {!isInstagramOrFacebook() && typeof google !== 'undefined' && google &&
        <Box 
          sx={{ 
            pb: loginViewIndex === 1 ? 0 : 3, mb: loginViewIndex === 1 ? 0 : 2,
            pt: 2, mt: 6,
            width: '275px',
            backgroundColor: 'whitesmoke',
            boxShadow: 3, borderRadius: 3,
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
          }}
        >
          <Box id="signInDiv"
            className="g-signin2" data-width="300" data-height="200"
            sx={{ 
              border: 0,
              boxShadow: 2,
            }}
          >
          </Box>

          {loginViewIndex === 1 &&
            <Typography 
              component='pre'
              textAlign={'left'}
              sx={{
                mt: 2, mb: 2,
                width: '90%',
                fontStyle: 'italic',
                color: 'blue',
                fontSize: '14px',
              }}
            >
              *By using this method you agree to the <a href='/tos' target="#" style={{ cursor: 'pointer', textDecoration: 'underline', color: 'dodgerblue' }} >Terms of Service</a> and <a href='/privacy' target="#" style={{ cursor: 'pointer', textDecoration: 'underline', color: 'dodgerblue' }} >Privacy Policy</a>
            </Typography>
          }
        </Box>
      }

      {/* Google Login Errors */}
      {!isInstagramOrFacebook() && googleLoginErrors && 
        standardErrorContainer(
          'Error logging in with Google.', 
          2,
          0
        )
      }
      
      {!isInstagramOrFacebook() && dividerWithText(
        275, 
        'black', 
        'black', 
        3,
        3
      )}

      {/* Login Form */}
      {loginViewIndex === 0 && 
        inProcessLogin(fromComponent, loginForm, setLoginForm, loginErrors, setLoginErrors, loadingLogin, setLoadingLogin, loginViewIndex, setRegisterErrors, setLoadingRegister, setLoadingGoogle, setGoogleLoginErrors, setLoadingFacebook, setFacebookLoginErrors, navigate, width)
      }
      
      {/* Register Form */}
      {loginViewIndex === 1 &&
        inProcessRegister(
          fromComponent, registerForm, setRegisterForm, registerErrors, setRegisterErrors, loadingRegister, setLoadingRegister, acceptedTOS, setAcceptedTOS, loginViewIndex, setLoginErrors, setLoadingLogin, navigate, 
          setLoadingGoogle, setGoogleLoginErrors, setLoadingFacebook, setFacebookLoginErrors,
          width
        )
      }

    </>
  )
}